import type { AuthUser } from "@/types/auth-user";

const noop = (user: AuthUser | undefined) => {
  void user;
};

export const useAuth = () => {
  return {
    userDetails: undefined as AuthUser | undefined,
    setUserDetails: noop,
    loading: false,
  };
};
